import { render, staticRenderFns } from "./NewFolder.vue?vue&type=template&id=18d72ab9"
import script from "./NewFolder.vue?vue&type=script&setup=true&lang=js"
export * from "./NewFolder.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NewFolder.vue?vue&type=style&index=0&id=18d72ab9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports